export const EVERY_TABLE_GROUP = 'On every selected table';

export function tableCoverageGroup(partial, names = []) {
  if (!partial) return EVERY_TABLE_GROUP;
  const label = (names || []).filter(Boolean).join(', ');
  return `${label || 'One table'} only`;
}
